import React from "react";
import Grid from "@mui/material/Unstable_Grid2";
import { Box, Link } from "@mui/material";
import AddCdBalance from "../AddCdBalance/AddCdBalance";
import "../CDLedger/CDLedger.scss";
function CDLedger() {
  const [addCdBalance, setAddCdBalance] = React.useState(false);
  const ledger_table = [
    {
      ledgerID: "TR34567890",
      date: "10 Jan,2023",
      description: "Member Addition",
      opening_Bal: "₹ 10,00,000",
      Debit: "₹ 50,000",
      Credit: "-",
      CD_Bal: "₹ 5,000,00",
    },
    {
      ledgerID: "TR34567891",
      date: "10 Jan,2023",
      description: "Member Addition",
      opening_Bal: "₹ 10,00,000",
      Debit: "₹ 50,000",
      Credit: "-",
      CD_Bal: "₹ 5,000,00",
    },
    {
      ledgerID: "TR34567893",
      date: "10 Jan,2023",
      description: "Member Deletion",
      opening_Bal: "₹ 10,00,000",
      Debit: "-",
      Credit: "₹ 50,000",
      CD_Bal: "₹ 5,000,00",
    },
    {
      ledgerID: "TR34567894",
      date: "10 Jan,2023",
      description: "Member Deletion",
      opening_Bal: "₹ 10,00,000",
      Debit: "-",
      Credit: "₹ 50,000",
      CD_Bal: "₹ 5,000,00",
    },
  ];
  const updateMasterState = (attrName: any, value: any) => {
    attrName(value);
  };

  return (
    <div>
      <Grid container spacing={3} style={{ textAlign: "right" }}>
        <Grid xs={12}>
          <Link
            underline="none"
            className="blueBtn addfile"
            onClick={() => {
              setAddCdBalance(true);
            }}
          >
            Add CD Balance
          </Link>
        </Grid>
      </Grid>
      <Box className="detailSection">
        <div className="sectionTitle">
          <h4>CD Ledger </h4>
        </div>

        <Grid container spacing={3}>
          <Grid xs={12}>
            <div className="cdledger">
              <div className="cdledger-table">
                <ul className="heading">
                  <li>
                    Ledger ID
                    <button className="sorting-btn">
                      {/* <img src="./images/sorting_btn.svg" alt="" /> */}
                    </button>
                  </li>
                  <li>
                    Date
                    <button className="sorting-btn"></button>
                  </li>
                  <li>
                    Description
                    <button className="sorting-btn"></button>
                  </li>
                  <li>
                    Opening Balance
                    <button className="sorting-btn"></button>
                  </li>
                  <li>
                    Debit
                    <button className="sorting-btn"></button>
                  </li>
                  <li>
                    Credit
                    <button className="sorting-btn"></button>
                  </li>
                  <li>
                    CD Balance
                    <button className="sorting-btn"></button>
                  </li>
                </ul>

                {ledger_table.map((data, index) => (
                  <ul className="subheading">
                    <li>{data.ledgerID}</li>
                    <li>{data.date}</li>
                    <li>{data.description}</li>
                    <li>{data.opening_Bal}</li>
                    <li>{data.Debit}</li>
                    <li>{data.Credit}</li>
                    <li>{data.CD_Bal}</li>
                  </ul>
                ))}
              </div>
            </div>
          </Grid>
        </Grid>
      </Box>
      <AddCdBalance
        attrName={setAddCdBalance}
        open_status={addCdBalance}
        value_update={updateMasterState}
      />
    </div>
  );
}

export default CDLedger;
